import { PaletteColor, createTheme } from '@mui/material/styles';

const { palette } = createTheme();

declare module "@mui/material/styles" {
  interface Palette {
    lightGrey: PaletteColor;
  }
  interface PaletteOptions {
    lightGrey: PaletteColor;
  }
}

declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
    lightGreen: true;
    grey: true;
  }
}

const gaiaTheme = createTheme({
  components: {
    MuiButton: {
      defaultProps: {
        disableRipple: true,
        color: 'primary',
        variant: 'contained',
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
      variants: [
        {
          props: { variant: 'text' },
          style: {
            backgroundColor: 'white',
            color: 'primary.main'
          }
        }
      ]
    },
    MuiTab: {
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          textTransform: 'capitalize',
        }
      }
    }
  },
  typography: {
    fontFamily: [
      'EffraMd',
      'EffraRg',
      'Effra',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif'
    ].join(','),
    body1: {
      fontFamily: [
        'EffraRg',
        'EffraMd',
        'Effra',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif'
      ].join(',')
    }
  },
  palette: {
    primary: {
      main: '#70942c',
      light: '#a3c15a',
      dark: '#3a5f13',
      contrastText: "#fff"
    },
    secondary: {
      main: "#c9da9e",
      contrastText: "#111E21"
    },
    lightGrey: palette.augmentColor({
      color: {
        main: '#e7e7e7',
        light: '#f1f1f1',
        dark: '#0000001f'
      }
    }),
    text: {
      primary: "#111E21"
    },
    error: {
      main: '#f44336',
      light: '#f6685e',
      dark: '#aa2e25',
    },
    warning: {
      main: '#ff9800',
      light: '#ffb74d',
      dark: '#f57c00',
      contrastText: '#fff',
    },
  },
  shape: {
    borderRadius: 10
  }
});


export default gaiaTheme;